// Grid configuration
export const GRID_COLS = 6;
export const GRID_ROWS = 4;
export const CELL_SIZE = 80;
export const GEM_SIZE = 60;

// Gem types and tiers
export const GEM_TYPES = ['ruby', 'sapphire', 'emerald'];
export const GEM_NAMES = {
  ruby: 'Ruby',
  sapphire: 'Sapphire',
  emerald: 'Emerald'
};
export const GEM_ELEMENTS = {
  ruby: 'Fire',
  sapphire: 'Ice',
  emerald: 'Nature'
};

// Gem colors by tier
export const GEM_COLORS = {
  ruby: ['#ff6b6b', '#ee5a5a', '#cc4444'],
  sapphire: ['#4dabf7', '#339af0', '#228be6'],
  emerald: ['#51cf66', '#40c057', '#37b24d']
};

// Mana configuration
export const MAX_MANA = 10;
export const MANA_REGEN_RATE = 2; // per second
export const GEM_COSTS = [0, 2, 4, 8]; // tier 0 unused, tier 1-3

// Difficulty settings
export const DIFFICULTIES = {
  rough: {
    id: 'rough',
    name: 'Rough',
    subtitle: 'Beginner',
    startingMana: 15,
    manaRegenRate: 3,
    wave1EnemyHpMultiplier: 1.2, // 60 HP instead of 50 (base is ~50)
    cursedShards: false
  },
  polished: {
    id: 'polished',
    name: 'Polished',
    subtitle: 'Intermediate',
    startingMana: 4,
    manaRegenRate: 2,
    wave1EnemyHpMultiplier: 1.0,
    cursedShards: false
  },
  flawless: {
    id: 'flawless',
    name: 'Flawless',
    subtitle: 'Expert',
    startingMana: 4,
    manaRegenRate: 2,
    wave1EnemyHpMultiplier: 1.0,
    cursedShards: false
  },
  cursed: {
    id: 'cursed',
    name: 'Cursed',
    subtitle: 'Impossible',
    startingMana: 4,
    manaRegenRate: 2,
    wave1EnemyHpMultiplier: 1.0,
    cursedShards: true
  }
};

// Cursed Shard configuration
export const CURSED_SHARD_COLOR = 0x8b5cf6; // Purple

// Battle configuration
export const TOTAL_WAVES = 8;
export const BASE_ENEMY_HP = 50;
export const BASE_PLAYER_DAMAGE = 10;
export const BASE_PLAYER_HP = 30;

// Animation timing
export const MERGE_ANIMATION_DURATION = 300;
export const DRAG_SNAP_BACK_DURATION = 200;

// Seed configuration
export const MAX_SEED_LENGTH = 64;
export const DEFAULT_SEED_LENGTH = 12;

// Speed multipliers
export const SPEED_MULTIPLIERS = [1, 2];
